module.exports = __webpack_public_path__ + "media/images/lig/life-is-good-hero-b62da1dff6f7da354cd4d818f6309dc5.jpg";